import LayoutScreen from '../../components/layout';
import iconArrowLeft from '../../assets/icon/icon_arrow_left.svg';
import iconCredit from '../../assets/icon/icon_credit.svg';
import Button from '../../components/button';
import ButtonLarge from '../../components/buttonLarge';

import { useNavigate } from 'react-router-dom';
import FormBuatProfile from './formBuatProfile';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import CONFIG from '../../config/apiConfig';
import useGuid from '../../components/hook/useGuid';
import { ProfileContext } from '../../components/context/profileContext';

const PageBuatProfile = (props) => {
  const { profile } = useContext(ProfileContext);
  const { maxCredit, limitCredit } = useGuid();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/'); // Programmatically navigate to /new-route
  };

  const handleSelanjutnya = () => {
    navigate('/scan'); // Programmatically navigate to /new-route
  };

  return (
    <LayoutScreen>
      <div className="relative flex flex-col flex-grow h-full px-0 py-5 md:p-10">
        <div className="h-full flex flex-col flex-grow justify-between items-center">
          <div className=" w-full flex space-x-4 justify-between items-start px-5">
            <div
              onClick={() => handleBack()}
              className="w-full w-full cursor-pointer flex space-x-2 md:space-x-4 justify-start items-center ">
              <img
                src={iconArrowLeft}
                alt="icon arrow left"
                className="w-5 h-5 md:w-8 md:h-8 object-contain"
              />
              <div className="w-full w-full md:text-2xl font-semibold text-textBlack">
                Isi Data Profil
              </div>
            </div>

            {!profile && (
              <div className="w-full flex flex-col space-y-2 justify-start items-end">
                <div className="flex justify-center items-center space-x-2 px-3 py-1 md:px-4 md:py-2 border border-red rounded-xl">
                  <img
                    src={iconCredit}
                    alt="icon credit"
                    className="w-4 h-4 md:w-5 md:h-5 object-contain"
                  />
                  <span className="text-red text-sm md:text-base">Credit : {limitCredit}</span>
                </div>

                <div className="text-xs md:text-sm text-textGray text-right">
                  Batas pemeriksaan kulit {maxCredit} kali/hari
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-grow w-full h-full py-5">
            <FormBuatProfile
              credit={limitCredit}
              onSubmitForm={(payload) => handleSelanjutnya(payload)}
            />
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageBuatProfile;
